export class ConfigurationParameter {
    configurationParameterId: number;
    expirationPeriodMFA: string;
    platformUrl: string;
    typeOfEnvironment: number;
    typeOfPlatform: number;
    rabbitMqUrl: string;
  }
  